import {
  useComposerDraftStore,
  type PersistedComposerImageAttachment,
} from "../../composerDraftStore";
import type { ScopedThreadRef } from "@cmmd-forge/contracts";
import { readFileAsDataUrl } from "../ChatView.logic";
import { buildPersistedComposerImageAttachments } from "./ChatComposer.logic";

/** Finish reading files before a remote send can connect and replace the composer. */
export async function persistRemoteComposerImages(
  threadRef: ScopedThreadRef,
): Promise<ReadonlyArray<PersistedComposerImageAttachment>> {
  const store = useComposerDraftStore.getState();
  const draft = store.getComposerDraft(threadRef);
  if (!draft?.images.length) return [];
  const attachments = await buildPersistedComposerImageAttachments({
    images: draft.images,
    existingPersistedAttachments: draft.persistedAttachments,
    readFileAsDataUrl,
  });
  if (attachments.length !== draft.images.length) {
    throw new Error("An image could not be saved. Add it again before sending.");
  }
  store.syncPersistedAttachments(threadRef, attachments);
  return attachments;
}
